import { useCallback, useEffect, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import { signOut } from '../../reducks/users/operations';
import { db } from '../../firebase';
import { RootState } from '../../reducks/store/store';
import { getIsSignedIn, getRole } from '../../reducks/users/selectors';
import { useNavigate } from 'react-router-dom';

type Props = {
  onClose?: (e: any) => void;
};

export const MenuColumn: VFC<Props> = (props) => {
  const { onClose } = props;

  const dispatch = useDispatch();
  const selector = useSelector((state: RootState) => state);

  const isSignedIn = getIsSignedIn(selector);
  const role = getRole(selector);
  const navigate = useNavigate();

  /**
   * 選択したメニュー先に遷移.
   *
   * @param e - event
   * @param path - 遷移先のパス
   */
  const selectMenu = useCallback((e: any, path: string) => {
    navigate(path);

    // ドロワーメニューなら、閉じる
    if (onClose) {
      onClose(e);
    }
  }, [navigate, onClose]);

  // メニューリスト
  let menus: Array<any> = [];
  if (isSignedIn && role === 'customer') {
    menus = [
      {
        func: selectMenu,
        label: 'メニュー',
        icon: <HomeIcon />,
        id: 'menu',
        value: '/', // 遷移先のパス
      },
      {
        func: selectMenu,
        label: '注文履歴',
        icon: <HistoryIcon />,
        id: 'history',
        value: '/order/history', // 遷移先のパス
      },
      {
        func: selectMenu,
        label: 'プロフィール',
        icon: <PersonIcon />,
        id: 'profile',
        value: '/user/my-page', // 遷移先のパス
      },
    ];
  }
  if (isSignedIn && role === 'admin') {
    menus = [
      {
        func: selectMenu,
        label: '商品登録',
        icon: <AddCircleIcon />,
        id: 'register',
        value: '/product/edit', // 遷移先のパス
      },
    ];
  }
  if (!isSignedIn) {
    menus = [
      {
        func: selectMenu,
        label: 'アカウント登録',
        icon: <PersonIcon />,
        id: 'signup',
        value: '/signup', // 遷移先のパス
      },
      {
        func: selectMenu,
        label: 'login',
        icon: <PersonIcon />,
        id: 'login',
        value: '/signin', // 遷移先のパス
      },
    ];
  }

  // // マウント時にフィルターメニューを取得
  useEffect(() => {
    const q = query(collection(db, 'categories'), orderBy('order', 'asc'));
    getDocs(q).then((snapshots) => {
      const list: Array<any> = [];
      snapshots.forEach((snapshot) => {
        const data = snapshot.data();
        list.push({
          func: selectMenu,
          label: data.name,
          id: data.id,
          value: `/?category=${data.id}`,
        });
      });
    });
  }, [selectMenu]);

  return (
    <div className={'w-full'}>
      {onClose && (
        <button
          onClick={(e) => {
            if (onClose) {
              onClose(e);
            }
          }}
          className='mt-3 ml-3 text-pandacco  rounded-md p-1'
        >
          閉じる
        </button>
      )}
      <Divider />
      <List>
        {menus.map((menu) => (
          <ListItem
            button
            key={menu.id}
            onClick={(e) => menu.func(e, menu.value)}
          >
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.label} />
          </ListItem>
        ))}
        {isSignedIn && (
          <ListItem
            button
            key='logout'
            onClick={(e) => {
              dispatch(signOut(navigate));
              if (onClose) {
                onClose(e);
              }
            }}
          >
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary={'Logout'} />
          </ListItem>
        )}
      </List>
    </div>
  );
};
